import React from "react";
import "../styles/about.css";
import Img1 from "../img/foto_pefil.jpg";

const AboutUs = () => {
  return (
      <div className="row" id="AboutMe">
        <div id="imgContainer"className="col-lg-6 col-md-12">
          <img className="img1" src={Img1} alt="Profile"/>
        </div>
        <div className="col-lg-6 col-md-12">
          <div
            className="w3-content w3-justify w3-padding-64"
            id="about"
          >
            <h2 className="w3-text-blue-grey">Nicolas Muñoz</h2>
            <hr className="w3-opacity" />
            <p>
              Administrador de empresas y Técnico en sistemas con más de
              15 años de experiencia en el área de IT, poseo varias
              certificaciones en networking, Iot, análisis de datos y desarrollo
              web. Actualmente desempeñando como (freelance) contratista IT
              ofreciendo soluciones a empresas que no cuentan con departamento
              de sistemas, prestando servicios que van desde administración y
              soporte hasta el desarrollo e instalación de infraestructuras IT.
              He ejecutado y participado en varios proyectos de automatización
              (residencial,comercial),montaje de redes de voz datos,
              sistemas de seguridad electrónica.Me siento muy orgulloso de
              todo lo que he logrado hasta ahora y estoy emocionado de seguir
              creciendo y aprendiendo en mi carrera. Mi experiencia en la
              tecnología y mi educación en administración de empresas me han
              brindado habilidades valiosas en liderazgo, gestión y toma de
              decisiones. Me apasiona mi trabajo y estoy comprometido a seguir
              aprendiendo y creciendo en mi carrera.
            </p>
          </div>
        </div>
      </div>
  );
};

export default AboutUs;
